import { SponsoredSavings } from "../types";

export const isEnrolledInSponsoredSavings = (
  sponsoredSavingsData: SponsoredSavings
) => {
  // check if program is enabled and user is enrolled
  const isEnrolledInSSP =
    sponsoredSavingsData.enabled && sponsoredSavingsData.is_enrolled;

  return isEnrolledInSSP;
};

export const calculateGoalProgress = (
  currentBalance: string | undefined,
  goal: string | undefined
) => {
  if (currentBalance && goal) {
    const balanceNumber = Number(currentBalance);
    const goalNumber = Number(goal);
    return (balanceNumber / goalNumber) * 100;
  }
  return 0;
};
